import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default () => {
  return {
    path: "chat-history",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([import(/* webpackChunkName: "ai" */ "./components")]).then(
          ([importedModule0]) => {
            const component = importedModule0.default;
            return component;
          }
        )
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [],
  };
};
